module.exports = __webpack_public_path__ + "img/user-3.79de645c.png";